{
  "roles_list_page": {
    "title": "Roles",
    "description": "Manage permissions and access levels for your sales team.",
    "footer": "Learn more about roles",
    "create_button": "Create role",
    "table": {
      "headings": {
        "name": "Name",
        "type": "Type",
        "assigned": "Assigned",
        "actions": "Actions"
      },
      "type_system": "System role",
      "type_custom": "Custom role"
    },
    "sections": {
      "sales_rep_roles": "Sales rep roles",
      "company_roles": "Company roles"
    }
  },
  "role_form_page": {
    "create_title": "Create role",
    "edit_title": "Edit {name}",
    "role_details": "Role details",
    "role_details_description": "This appears as an option when assigning roles to your sales team.",
    "name_label": "Name",
    "slug_label": "Slug",
    "display_name_label": "Name",
    "display_name_placeholder": "e.g. Rep on the road",
    "handle_label": "Handle (or ID)",
    "handle_placeholder": "e.g. rep-on-the-road",
    "type_label": "Type",
    "type_customer": "Company role",
    "type_sales": "Sales rep role",
    "permissions": "Permissions",
    "permissions_description": "Customise access levels for this role.",
    "delete_confirm_title": "Delete role?",
    "delete_confirm_body": "Are you sure you want to delete \"{name}\"? This can't be undone."
  },
  "list_page": {
    "title": "Customers",
    "heading": "Customers",
    "footer": "Learn more about customers",
    "description": "List of all customers that can place B2B orders on your store.",
    "customers_table": {
      "caption": "Your customers"
    },
    "empty_state": {
      "title": "No customers found",
      "subtitle": "List of all customers customers that can place B2B orders on your store."
    }
  },
  "sales_agent_overview_page": {
    "title": "Sales agents",
    "heading": "Sales team",
    "footer": "Learn more about sales agents",
    "description": "Sales agents can place orders and manage accounts on behalf of your B2B customers.",
    "customers_table": {
      "caption": "Your agents"
    },
    "empty_state": {
      "no_agents_available": {
        "title": "Sales agents are not included in your plan",
        "subtitle": "Upgrade your plan to start using sales agents to place orders on behalf of your customers."
      },
      "agents_available": {
        "title": "No sales agents found",
        "subtitle": "Add sales agents to your team to start managing orders on behalf of your customers.",
        "add_button": "Add sales agent"
      }
    }
  },
  "customer_details_page": {
    "description": "This information is pulled from your connected platform.",
    "footer": "Learn more about customer metafields",
    "company_user_alert": {
      "main": {
        "title": "Standard company user",
        "message": "This customer belongs to a company account with shared orders, shopping lists, and addresses. They can place orders and view all account activity."
      },
      "limited": {
        "title": "Limited company user",
        "message": "This customer belongs to a company account with shared orders, shopping lists, and addresses. They can add items to orders but can't complete checkout — all orders require approval from the company account owner."
      }
    },
    "information": {
      "title": "Basic information",
      "email": "Email",
      "company": "Company",
      "customer_group_slug": "Customer Group",
      "price_lists": "{length, plural, one {Price list overwrite} other {Price list overwrites}}",
      "sales_agent_groups": "{length, plural, one {Sales Agent Group} other {Sales Agent Groups}}"
    },
    "view_in_platform": "View in {platform}"
  },
  "staff_customer_sync_page": {
    "title": "Customer Sync - Staff",
    "heading": "Customer Sync - Staff",
    "footer": "Learn more about companies",
    "description": "View and manage customers sync.",
    "search_placeholder": "Search external_id…",
    "customers_table": {
      "caption": "Your companies"
    },
    "empty_state": {
      "title": "No companies found",
      "subtitle": "Companies represent all customers that can place B2B orders on your store."
    },
    "actions": {
      "manual_sync": "Manually synchronise customers"
    }
  },
  "customers_sync_page": {
    "title": "Customer Sync",
    "description": "This synchronises customer data from your eCommerce platform.",
    "lookup_title": "Customer Data Lookup",
    "lookup_description": "You can search and diagnose the customer data you're sending to SparkLayer below.",
    "search_placeholder": "Enter Customer ID",
    "not_found": {
      "title": "Customer not found",
      "description": "Sorry, no customer was found for the customer ID \"{identifier}\". Please try searching again."
    },
    "search_table": {
      "caption": "Customer search results",
      "headings": {
        "customer": "Customer",
        "external_id": "External ID"
      }
    },
    "summary": {
      "title": "Customer summary",
      "full_name": "Full name",
      "email": "Email",
      "external_id": "External ID",
      "internal_id": "Internal ID"
    },
    "details": {
      "title": "Customer details",
      "view_in_platform": "View customer in {platform}"
    },
    "sales_agent_upsell": {
      "title": "Your SparkLayer plan comes with sales agents",
      "description": "With our sales agent feature you can place orders and manage accounts on behalf of your customers.",
      "upgrade": "Upgrade today"
    },
    "actions": {
      "manual_sync": "Manually synchronise customers",
      "save_role": "Save"
    },
    "notifications": {
      "sync_started": "Customer synchronisation started.",
      "role_updated": "Successfully changed the customer's role",
      "role_update_limit_error": "Your plan limit of sales agents has been hit, please check your plan or contact support.",
      "system_error": "A system error occurred, please wait a few minutes and try again."
    }
  },
  "customer_sync_data_page": {
    "title": "Customer Data",
    "description": "The customer data SparkLayer holds for customer ID \"{identifier}\"."
  },
  "sales_agents_page": {
    "title": "Sales agents",
    "description": "Sales agents can place orders and manage accounts on behalf of your B2B customers.",
    "lookup_title": "Manage your Sales agents",
    "lookup_description": "To get started and assign a Sales agent, you can use the Customer Data Lookup tool below.",
    "upsell": {
      "title": "Empower your Sales team.",
      "subtitle": "Tired of juggling phone orders and endless email threads from customers wanting to place wholesale orders? SparkLayer's Sales agent tool puts you in the driver's seat and lets you place and manage B2B orders through your website.",
      "use_cases": {
        "place_orders": {
          "title": "Place B2B orders for your customers",
          "description": "Login on behalf of your customers and easily place orders for them."
        },
        "offline_orders": {
          "title": "Manage offline orders",
          "description": "Use this tool for placing B2B phone orders or in-person trade show orders."
        },
        "reorder": {
          "title": "Quickly re-order for your customers",
          "description": "Login to their account, view order history, and repeat orders in seconds."
        }
      }
    }
  }
}
